window.JobDistributorAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    var url = publicConfiguration.JobDistributorServerBaseURL;
    _protected.setApiUrl(url);

    self.getJobBoardsSummary = function (boards) {
        var jobBoards = {
            published: 0,
            pending: 0,
            failure: 0,
            all: 0
        };
        if (boards.length > 0) {
            for (var j in boards) {
                var board = boards[j];
                switch (board.status) {
                    case "PUBLISHED":
                    case "ARCHIVED":
                        jobBoards.published++;
                        break;
                    case "PENDING":
                    case "PENDING_APPROVAL":
                    case "PENDING_APPROVAL":
                    case "PENDING_SCHEDULED":
                        jobBoards.pending++;
                        break;
                    case "FAILURE":
                    case "HARRI_FAILURE":
                    case "REJECTED":
                        jobBoards.failure++;
                        break;
                }
                jobBoards.all++;
            }
        }
        return jobBoards;
    };
    self.checkBoardsValidation = function (jobIds, boards) {
        var deferred = $q.defer();
        let payload = {'boards': boards};
        if (jobIds.length > 1) {
            payload['job_ids'] = jobIds;
            _protected.request('jobs/boards/payments/validation', 'POST', payload)
                .then(function (result) {
                    deferred.resolve(result.data);
                }).catch(function (err) {
                console.error(err);
                deferred.reject(err);
            });
        } else {
            _protected.request('jobs/' + jobIds[0] + '/boards/payments/validation', 'POST', payload)
                .then(function (result) {
                    deferred.resolve(result.data);
                }).catch(function (err) {
                console.error(err);
                deferred.reject(err);
            });
        }
        return deferred.promise;
    };

    self.getBoardsDetails = function(brandId,jobsIds) { // boost a job
        var deferred = $q.defer();
        var params = {job_ids:jobsIds.join(",")};
        _protected.request("brands/" + brandId + "/jobs/boards", "GET", params)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;

    };

    /** GET Job Board Details
     * return board Array {"boards": [ { "status": "PENDING"/"PUBLISHED",image_url": "", "name": "Indeed"}]}
     }
     * @param brandId
     * @returns {deferred.promise|{then}|{then, always}}
     */
    self.getJobBoardDetails = function (brandId, jobId) {
        var deferred = $q.defer();

        var params = {};

        _protected.request("brands/" + brandId + "/jobs/" + jobId + "/boards", "GET", params)
            .then(function (res) {
                    if (res.data && res.data.data && res.data.status_code == 200) {
                        deferred.resolve(res.data.data);
                    }
                    else {
                        deferred.reject(res);
                    }
                },
                function (err) {
                    console.error(err);
                    deferred.reject(err);
                });

        return deferred.promise;
    };

    self.rePublishJobOnBoards = function (brandId, jobId, code) {
        var deferred = $q.defer();


        _protected.request("brands/" + brandId + "/jobs/" + jobId + "/boards/" + code + "/publish", 'POST')
            .then(function (res) {
                if (res.data && res.data.data && res.data.status_code == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /** DELETE Activated FB Page
     * @param brandId
     * @returns {deferred.promise|{then}|{then, always}}
     */

});